import React from 'react';
import { MechanismSection } from './MechanismSection';
import { GuideSection } from './GuideSection';
import { BonosSection } from './BonosSection';
import { OfferSection } from './OfferSection';
import { HowItWorks } from './HowItWorks';
import { Guarantee } from './Guarantee';
import { FAQ } from './FAQ';
import { ClosingBlock } from './ClosingBlock';
import { Footer } from './Footer';
import { FloatingCTA } from './FloatingCTA';
export function DeferredLanding() {
  return <>
      <MechanismSection data-id="element-32" data-mp="o8l5588jak1c" />
      <GuideSection data-id="element-33" data-mp="o7a61lq1a0gk" />
      <BonosSection data-id="element-34" data-mp="o7tlmvs7ocrf" />
      <OfferSection data-id="element-35" data-mp="o6ik72m8nh3h" />
      <HowItWorks data-id="element-36" data-mp="11zglt6p9y5fh" />
      <Guarantee data-id="element-37" data-mp="11zzstsddz9eq" />
      <FAQ data-id="element-38" data-mp="11yexw1n5togc" />
      <ClosingBlock data-id="element-39" data-mp="11z83v0eao9xf" />
      <Footer data-id="element-40" data-mp="121kmlfrvmobj" />
      <div className="h-[54px] md:hidden" aria-hidden="true" data-id="element-41" data-mp="x0n8pfdwggfu" />
      <FloatingCTA data-id="element-42" data-mp="x1f1kig4402f" />
    </>;
}